module.exports = __webpack_public_path__ + "img/user_WangYilong.d05ce048.png";